export const calculateApr = (
  totalEmission: number,
  totalSharedAmountDeposit: number,
  totalxVirtualSupply: number,
  totalDeposit: number
) => {
  totalEmission = 40000000;

  return (
    ((totalEmission * (totalSharedAmountDeposit / totalxVirtualSupply)) /
      totalDeposit) *
    0.5 *
    100
  );
};
